import { instanceOfPensionBeneficiary, type Beneficiary, type PensionBeneficiary } from "@repo/api";
import { indicateStarPensionEmptyAddress } from "../../AddressBox/AddressTemplate";

export const cleanAddress = (address: Record<string, unknown>) => {
    const cleanedAddress = Object.keys(address)
        .filter((item) => address[item])
        .reduce<Record<string, unknown>>((obj, key) => {
            obj[key] = address[key];
            return obj;
        }, {});
    return cleanedAddress;
};

export const beneficiariesInitialValues = (
    beneficiaries: (PensionBeneficiary | Beneficiary)[],
): (PensionBeneficiary | Beneficiary)[] =>
    beneficiaries.map<PensionBeneficiary | Beneficiary>((beneficiary) => {
        const isPensionBeneficiary = instanceOfPensionBeneficiary(beneficiary);
        const { firstName, lastName, dateOfBirth, address, birthNumber } = beneficiary;
        return {
            firstName,
            lastName,
            dateOfBirth: dateOfBirth ? new Date(dateOfBirth) : null,
            birthNumber,
            id: isPensionBeneficiary ? beneficiary.id : undefined,
            relationship: beneficiary.relationship,
            address: {
                ...address,
                zip: address?.zip && !indicateStarPensionEmptyAddress(address) ? address.zip : "",
            },
            existsOnBE: true,
        } as PensionBeneficiary | Beneficiary;
    });

export const ratiosInitialValues = (beneficiaries: (PensionBeneficiary | Beneficiary)[]) =>
    beneficiaries.map(({ ratio }) => {
        return {
            ratio,
        };
    });
